import { useTranslation } from 'react-i18next';
import { i18nNS } from '../i18n';

const useGender = (returnSelect = true) => {
  const { t } = useTranslation(i18nNS.common);
  const gender = [];

  if (returnSelect) {
    gender.push({
      label: t('common:Gender.Select'),
      value: null,
    });
  }

  gender.push(
    {
      label: t('common:Gender.Male'),
      value: 'M',
    },
    {
      label: t('common:Gender.Female'),
      value: 'F',
    },
    {
      label: t('common:Gender.Unspecified'),
      value: 'X',
    }
  );
  return [gender];
};

export default useGender;
